import { P } from "@cd2/text/build/es6"
import { IComponentProps } from "@cd2/tools/build/es6"
import React from "react"

export function TextWithNewLines({
  text,
  paragraphProps = {},
}: {
  text: string
  paragraphProps?: Omit<IComponentProps<typeof P>, "children">
}) {
  const paragraphs = text
    .trim()
    .split("\n\n")
    .map(p => p.trim())

  return (
    <React.Fragment>
      {paragraphs.map((p, i) => (
        <P key={i} {...paragraphProps}>
          {p.split("\n").map((line, j) => (
            <React.Fragment key={j}>
              {j > 0 && <br />}
              {line}
            </React.Fragment>
          ))}
        </P>
      ))}
    </React.Fragment>
  )
}
